import axios, { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios';

interface ErrorResponse {
  statusCode?: number;
  message?: string;
  error?: string;
}

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 請求攔截器
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('API Request:', {
        url: config.url,
        method: config.method,
      });
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// 響應攔截器
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError<ErrorResponse>) => {
    let errorMessage = 'An unexpected error occurred';

    if (error.response) {
      // 伺服器回應了錯誤狀態碼
      errorMessage = error.response.data?.message || 
                    error.response.data?.error || 
                    error.response.statusText;

      switch (error.response.status) {
        case 401:
          // 處理未授權錯誤，可能是登入失敗或 token 過期
          if (typeof window !== 'undefined') {
            // 清除本地存儲的認證信息
            localStorage.removeItem('token');
            localStorage.removeItem('user');
          }
          break;
        case 403:
          errorMessage = 'Access denied';
          break;
        case 404:
          errorMessage = 'Resource not found';
          break;
        case 422:
          errorMessage = 'Validation error';
          break;
        case 500:
          errorMessage = 'Server error';
          break;
      }
    } else if (error.request) {
      // 請求已發送但沒有收到回應
      errorMessage = 'No response from server';
    }

    // 建立增強的錯誤對象
    const enhancedError = new Error(errorMessage);
    Object.assign(enhancedError, {
      response: error.response,
      status: error.response?.status,
      data: error.response?.data
    });

    return Promise.reject(enhancedError);
  }
);

// 添加認證 token 到請求頭
export const setAuthToken = (token: string | null) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

export default api;
